import { Element } from "@xmpp/xml"
import type { AppDispatch } from "../reducers/store"
import AccountChatsPubSubEventParser from "../lib/accountChatPubSubEventParser"
import {
  AccountChat,
  ACCOUNT_CHAT_NS,
  USER_CHAT_NS,
} from "../lib/accountChatsParser"
import {
  addAccountChat,
  removeAccountChat,
} from "../reducers/accountChatsSlice"
import { addUserChat, removeUserChat } from "../reducers/userChatsSlice"
import {
  parseServiceConfigEvent,
  SERVICE_CONFIG_NODE,
} from "../lib/serviceConfigParser"
import {
  setGpsServiceConfig,
  clearGpsServiceConfig,
  setIdentityConfig,
  clearIdentityConfig,
} from "../reducers/serviceConfigSlice"

export function handleAccountConfigEvents(
  stanza: Element,
  dispatch: AppDispatch,
  loggedInUserJidBare?: string,
): boolean {
  const itemsNode = stanza.getChild("event")?.getChild("items")
  if (!itemsNode) return false

  const node = itemsNode.getAttr("node")

  if (node === ACCOUNT_CHAT_NS) {
    const event = AccountChatsPubSubEventParser.parseAccountChat(stanza)
    if (!event) return false

    if (event.type === "create") {
      dispatch(addAccountChat(event.accountChat as AccountChat))
    } else if (event.type === "retract") {
      dispatch(removeAccountChat(event.accountChat.jid))
    }
    return true
  }

  if (node === USER_CHAT_NS) {
    // Explicit <retract> element — remove unconditionally
    const retractNode = itemsNode.getChild("retract")
    if (retractNode) {
      const retractId = retractNode.getAttr("id")
      if (retractId) {
        dispatch(removeUserChat(retractId))
      }
      return true
    }

    // <item> element — parser returns { type: "retract" } when user is not in allowed_users;
    // in that case we must dispatch removeUserChat to evict the chat if it was previously stored
    const event = AccountChatsPubSubEventParser.parseUserChat(
      stanza,
      loggedInUserJidBare,
    )
    if (!event) return true

    if (event.type === "create") {
      dispatch(addUserChat(event.accountChat as AccountChat))
    } else if (event.type === "retract") {
      dispatch(removeUserChat(event.accountChat.jid))
    }
    return true
  }

  if (node === SERVICE_CONFIG_NODE) {
    const event = parseServiceConfigEvent(stanza)
    if (!event) return true // matched node, but unparseable — consume

    if ("retract" in event) {
      if (event.itemId === "gps") dispatch(clearGpsServiceConfig())
      if (event.itemId === "identity") dispatch(clearIdentityConfig())
    } else if (event.itemId === "gps") {
      dispatch(setGpsServiceConfig(event.config))
    } else if (event.itemId === "identity") {
      dispatch(setIdentityConfig(event.config))
    }
    return true
  }

  return false
}
